import { GET_CLIENT_LIST } from "../../endpoints";
import makeAuthenticatedRequest from "../base-api";
import { IClient } from "../../types/brand";

export interface GetClientListResponse {
  success: boolean;
  message?: string;
  clients?: IClient[];
}

const getClientList = async (): Promise<GetClientListResponse> => {
 try {
  const response = await makeAuthenticatedRequest(GET_CLIENT_LIST);
  const result = await response.json();

  if (!result.success) {
    throw new Error(result.message);
  }

  return { clients: result.data, success: true };
 } catch (error) {
  console.error(error);
  throw error;
 }
}; 

export { getClientList };